import { Rating } from "@mui/material";
import styled from "styled-components";

export const StyledRating = styled(Rating)(({ theme }) => `
  .MuiRating-iconFilled {
    color: ${theme.uptimeColors.newsKnowledgeColors.rating};
  }
  .MuiRating-iconEmpty {
    color: #0000003b;
  }
`);
